import { DataType } from '@/screens/Order/Pages/EditOrder/components/ProductRequirementForm/measurement.column'
import HeaderComponent from '@/screens/SystemConfigure/Components/HeaderComponent/HeaderComponent'
import PopUpMenu from '@/screens/SystemConfigure/Components/PopUpMenu/PopUpMenu'
import ToolbarComponent from '@/screens/SystemConfigure/Components/ToolbarComponent/ToolbarComponent'
import { Space } from 'antd'
import Table, { ColumnsType } from 'antd/lib/table'
import { useState } from 'react'
import { useQuery } from 'react-query'
import './Users.style.less'
import { capitalize, debounce, toUpper } from 'lodash'
import {
  getAllUser,
  getCompanySetting,
  getRoles,
  inspectorSetting,
} from '../../UserManagment.transform'
import ModalUserDetail from './components/ModalUserDetail/ModalUserDetail'
import {
  COMPANY_SETTING_ENABLE_ACTIVATION,
  USER_ROLE,
  USER_SETTINGS_TYPE,
} from '@/constant/user'

function Users() {
  const [modalUsers, setModalUsers] = useState(false)
  const [page, setpage] = useState(1)
  const [search, setsearch] = useState('')
  const [selectedItem, setselectedItem] = useState(null)

  const hasInspectorSetting = useQuery(['inspector'], () =>
    inspectorSetting()
  ).data

  const dataRoles = useQuery(['roles'], () => getRoles())

  const { data: enableActiveData } = useQuery(
    ['company-setting/user'],
    async () => {
      const { value } = await getCompanySetting(
        'user',
        COMPANY_SETTING_ENABLE_ACTIVATION,
        ['name', 'value', 'type']
      )
      return { ...value }
    }
  )
  const settings: USER_SETTINGS_TYPE = {
    enableActivation: enableActiveData?.status,
  }
  const onEdit = (item) => {
    setselectedItem(item)
    setModalUsers(true)
  }

  const columns: ColumnsType<DataType> = [
    {
      title: 'Name',
      dataIndex: 'first_name',
      key: 'first_name',
      render: (_, record: any) => {
        return <p>{record?.first_name + ' ' + record?.last_name}</p>
      },
      // sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: (_, record: any) => {
        const role = record?.subscriptions[0]?.role_access.role

        if (!hasInspectorSetting && role === USER_ROLE.INSPECTOR) {
          return null
        }

        return <p>{role}</p>
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_, record: any) => {
        return <p>{capitalize(record?.status)}</p>
      },
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <PopUpMenu
            onEdit={() => onEdit(record)}
            // onDelete={() => onDelete(record)}
          />
        </Space>
      ),
      width: '5%',
    },
  ]

  const { data, isLoading } = useQuery(['Users', page, search], async () => {
    const payload = {
      page_number: page,
      page_size: 10,
      // status: 'active',
      search: search,
    }
    return getAllUser(payload)
  })

  const onSearch = debounce(async (value) => {
    setsearch(value)
  }, 500)

  return (
    <>
      <HeaderComponent title="Users" />
      <ToolbarComponent
        // onAdd={onAdd}
        buttonText="New Users"
        onSearch={onSearch}
      />
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={data?.data}
        pagination={{
          pageSize: 10,
          current: page,
          onChange(page) {
            setpage(page)
          },
          total: data?.pagination.total_record,
        }}
      />
      {modalUsers && (
        <ModalUserDetail
          onClose={() => setModalUsers(false)}
          visible={modalUsers}
          data={selectedItem}
          dataRoles={dataRoles.data}
          settings={settings}
        />
      )}
    </>
  )
}

export default Users
